import constants from '../constants';
import { SEND_STICKER_ERROR_KEY } from './reducer';

export const getDeal = state => state.deals.deal;

export const getCar = state => state.deals.car;

export const getDealer = state => state.deals.dealer;

export const getSelectedCars = state => state.deals.selectedCars;

export const getPayments = state => state.deals.payments;

export const getPencil = state => state.deals.pencil;

export const getError = state => state.deals[constants.ERROR_KEY];

export const getFetching = state => state.deals[constants.FETCHING_KEY];

export const getSendingSticker = state => state.deals.sendingSticker;

export const getSendingStickerError = state =>
  state.deals[SEND_STICKER_ERROR_KEY];

/**
 * Extract the primary vehicle set the deal using `car_id` property.
 */
export const getPrimarySelectedCar = state => {
  const deal = getDeal(state);
  const selectedCars = getSelectedCars(state);
  return selectedCars?.find(car => car.id === deal?.car_id);
};
